const state = {
  'dark-theme': {
    '--main-color':  '#DA291C',
    '--summary-panel-border-color': '#620A0A',
    '--panel-bar-bg-color': '#620A0A',
    '--white-color': '#FFFFFF',
    '--black-color': '#000000',
    '--main-title-color': 'var(--white-color)',
    '--header-right-label-color': 'var(--white-color)',
    '--dashboard-bg-color': 'var(--black-color)',
    '--dashboard-color': 'var(--black-color)',
    '--panel-body-bg-color': '#0B0F28',
    '--summary-panel-bg-color' :'linear-gradient(to bottom, #260A0A, var(--black-color))',
    '--summary-panel-bg-title-color': 'var(--white-color)',
    '--v-icon-color': 'var(--white-color)',
    '--tr-even-gradient-color-1': '#260A0A',
    '--tr-even-gradient-color-2': 'var(--black-color)',
    '--tr-odd-gradient-color': '#260A0A',
    '--period-box-bg-color': '#620A0A',
    '--period-box-menu-bg-color': '#620A0A',
    '--bar-chart-gradient': '#EEEE07',
    '--instagram-bg-color': 'var(--black-color)',
    '--instagram-title-color': 'var(--white-color)',
    '--chart-area-bg-color': '#620A0A',
    '--chart-area-border-color': '#620A0A',
    '--instagram-tr-even-gradient-color-1': 'var(--black-color)',
    '--line-chart-tooltip-border-color': '#333',
    '--line-chart-tooltip-bg-color': 'rgba(0,0,0,0.8)',
    '--line-chart-tooltip-title-color': 'var(--main-title-color)',
    '--line-chart-y-color': '#8D8C8E',
    '--line-chart-y-curve-color': '#00CBFF',
    '--left-area-item-odd-gradient-1': '#DA291C',
    '--left-area-item-odd-gradient-2': '#941414',
    '--symbol-details-button-bg-color': 'var(--white-color)',
    '--symbol-details-button-text-color': 'var(--black-color)',
    '--symbol-details-button-hover-color': '#9A9D9E',
    '--right-info-color': '#620A0A',
    '--multiple-selection-item-color': 'var(--white-color)'
  },
  'light-theme': {
    '--main-color':  '#DA291C',
    '--summary-panel-border-color': 'var(--main-color)',
    '--summary-panel-dark-color': 'var(--main-color)',
    '--panel-bar-bg-color': 'var(--main-color)',
    '--white-color': '#FFFFFF',
    '--black-color': '#000000',
    '--main-title-color': 'var(--black-color)',
    '--header-right-label-color': 'rgb(80, 84, 142)',
    '--dashboard-bg-color': 'var(--white-color)',
    '--dashboard-color': '',
    '--panel-body-bg-color': '#F0F0F0',
    '--summary-panel-bg-color': 'linear-gradient(to bottom, #E7E7E7, var(--white-color))',
    '--summary-panel-bg-title-color': 'var(--black-color)',
    '--v-icon-color': '',
    '--tr-even-gradient-color-1': 'var(--white-color)',
    '--tr-even-gradient-color-2': '#E7E7E7',
    '--tr-odd-gradient-color': 'var(--white-color)',
    '--period-box-bg-color': 'var(--main-color)',
    '--period-box-menu-bg-color': 'var(--main-color)',
    '--bar-chart-gradient': '#EEEE07',
    '--instagram-bg-color': '#F0F0F0',
    '--instagram-title-color': 'var(--black-color)',
    '--chart-area-bg-color': 'var(--white-color)',
    '--chart-area-border-color': 'var(--main-color)',
    '--instagram-tr-even-gradient-color-1': '#F0F0F0',
    '--line-chart-tooltip-border-color': '#DDD',
    '--line-chart-tooltip-bg-color': 'rgba(255,255,255,0.9)',
    '--line-chart-tooltip-title-color': 'var(--main-title-color)',
    '--line-chart-y-color': '#D4D2D6',
    '--line-chart-y-curve-color': '#00CBFF',
    '--left-area-item-odd-gradient-1': '#DA291C',
    '--left-area-item-odd-gradient-2': '#941414',
    '--symbol-details-button-bg-color': 'var(--white-color)',
    '--symbol-details-button-text-color': 'var(--black-color)',
    '--symbol-details-button-hover-color': '#9A9D9E',
    '--right-info-color': '#620A0A',
    '--multiple-selection-item-color': 'var(--black-color)'
  }
};

export default {
  namespaced: true,
  state
};
